import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap, take } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  
  const authenticationService = inject(AuthenticationService);
  
  if (authenticationService.isUrlInAuthorizedUrls(req.url)) {
    return handleRequest(authenticationService, req, next);
  } else {
    return next(req);
  }
  
}

function handleRequest(authenticationService: AuthenticationService, req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (authenticationService.tokenNeedsRefreshing()) {
    return authenticationService.refreshAuthentication$().pipe(
      take(1),
      switchMap(token => cloneRequest(req, next, token.accessToken))
    );
  }
  
  return cloneRequest(req, next, authenticationService.getAccessToken());
}

function cloneRequest(req: HttpRequest<unknown>, next: HttpHandlerFn, token: string) {
  const newReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  return next(newReq);
}
